const showLoading = () => {
  $('.global').append(`
    <div class="loading">
      <div class="loading__circle">
        <div class="sk-circle1 sk-circle"></div>
        <div class="sk-circle2 sk-circle"></div>
        <div class="sk-circle3 sk-circle"></div>
        <div class="sk-circle4 sk-circle"></div>
        <div class="sk-circle5 sk-circle"></div>
        <div class="sk-circle6 sk-circle"></div>
        <div class="sk-circle7 sk-circle"></div>
        <div class="sk-circle8 sk-circle"></div>
        <div class="sk-circle9 sk-circle"></div>
        <div class="sk-circle10 sk-circle"></div>
        <div class="sk-circle11 sk-circle"></div>
        <div class="sk-circle12 sk-circle"></div>
      </div>
    </div>`
  );
  $('html').css('overflow-y', 'hidden');
};

const stopLoading = () => {
  $('.loading').remove();
  $('html').css('overflow-y', 'auto');
};

export {
  showLoading,
  stopLoading
};



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/components/loading.js